<template>
  <section>
    <div class="mod-block">
      <h3 class="title">属性标签</h3>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
        <!-- <el-form-item prop="brandList" :rules="[{ validator: this.$validate.required, message: '属性标签不能为空'}]"></el-form-item> -->
        <el-form-item :label="item.lbName" :prop="'brandList['+index+'].lbValue'" :rules="[{ required: isValidate(item), message: ' ', trigger: 'blur,change'}]" v-for="(item, index) in form.brandList" :key="index">
          <el-select v-model="item.lbValue" clearable filterable>
            <el-option v-for="val in item.valueList" :key="val.ldName" :label="val.ldName" :value="val.ldName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getMod', 'getComData'],
    data () {
      return {
        basicInfo: {},
        form: {
          brandList: []
        }
      }
    },
    computed: {
      isItemEmpty () {
        let flag = true
        let ar = this.form.brandList || []
        for (let i = 0; i < ar.length; i++) {
          if (ar[i].lbValue !== null && ar[i].lbValue !== '' && ar[i].lbValue !== undefined) {
            flag = false
            break
          }
        }
        return flag
      }
    },
    methods: {
      isValidate (item) {
        if (this.isItemEmpty) {
          return false
        }
        return item.containType == 'Y'
      },
      getInfo () {
        let param = {
          __isRP: false,
          item: this.basicInfo.item,
          genId: this.basicInfo.genId
        }
        this.$ajax.post('/commodityarchives/appItemmasterLabels/selectItemLabelsByItemappIdAndAppitemidNew', param).then(res => {
          if(res && res.code == "0" && res.msg == "success"){
            let result = res.result || {};
            this.form.brandList = result.appItemmasterLabels || [];

            // let {editData} = this.getComData()
            /* if (editData.labelsList) {
              this.form.brandList = [].concat(editData.labelsList)
            } */

            this.form.brandList.forEach((item,i)=>{
              item.valueList = [];
              this.getValueByCtg(result.subclass, item.lbId, '', i); //小类，标签ID，标签值
            })
          }
        })
      },
      //查询类别关联的标签值
      getValueByCtg(code,id,val,i){
        let para= {
          ctgCode:code,  //小类
          lbId:id, //标签ID
          lbValue:val, //标签值或标签值KEY
        }
        this.$ajax.get('/labelsmanager/labelsDefine/selectLValueByCtg', para).then(res => {
          if(res && res.code == "200" && res.message == "success"){
            let data = res;
            if (res && res.res && res.res.data) {
              this.form.brandList[i].valueList = res.res.data || [];
            }
            this.form.brandList= JSON.parse(JSON.stringify(this.form.brandList));
          }else if (res.message) {
            this.$message.error(`${res.message}`);
          }
        });
      }
    },
    mounted () {
      // 编辑
      let $basicInfo = this.getMod('basicInfo')
      $basicInfo.$on('updated', () => {
        this.basicInfo = $basicInfo.form
        this.getInfo()
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/property-label.vue